// The hover tip these three charts share.
//
// Same construction as the session trace's: an absolutely positioned div inside
// the chart's own relative wrapper, flipped to the other side of the pointer
// once it passes the halfway mark so it never leaves the panel. Not a portal and
// not fixed positioning — the chart scrolls horizontally inside its card, and a
// fixed tip parts company with the mark it belongs to the moment it does.
import React from "react";
import { INK, MUTED, GRID, SURFACE } from "../../impact/tokens";

const Tip = ({ x, y, width, children }) => {
  const flip = x > width / 2;
  return (
    <div
      style={{
        position: "absolute",
        top: Math.max(0, y),
        left: flip ? undefined : x + 12,
        right: flip ? width - x + 12 : undefined,
        pointerEvents: "none",
        background: SURFACE,
        border: `1px solid ${GRID}`,
        borderRadius: 8,
        padding: "6px 9px",
        fontSize: 11.5,
        lineHeight: 1.45,
        color: INK,
        boxShadow: "0 2px 8px rgba(43,42,40,0.10)",
        maxWidth: 280,
        zIndex: 2,
      }}
    >
      {children}
    </div>
  );
};

// The muted half of a tip line — a unit, a count, a caveat.
const TipNote = ({ children }) => (
  <span style={{ color: MUTED }}>{children}</span>
);

export { Tip, TipNote };
